module.exports = __webpack_public_path__ + "img/17.8dc6193a.jpg";